import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { IdempotencyKey, } from "../../Types";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import postRaiseCash from "../requests/postRaiseCash";
export default function usePostRaiseCash(config) {
    const idemDescriptor = "post-raise-cash";
    const [idempotencyKeyBase, setIdempotencyKeyBase] = useState(genIdempotencyKey(idemDescriptor));
    const mutation = useMutation({
        mutationFn: async ({ planAssignmentId, body }) => {
            if (config === null) {
                throw new Error("no auth");
            }
            const idempotencyKey = IdempotencyKey.parse(`${idempotencyKeyBase}-${planAssignmentId}`);
            return postRaiseCash(config, planAssignmentId, body, idempotencyKey);
        },
        onSuccess: () => {
            setIdempotencyKeyBase(genIdempotencyKey(idemDescriptor));
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePostRaiseCash.js.map